import React from "react";
import GalleryImages from "../components/Gallery-Images";
import GalleryStacked from "../components/Gallery-Stacked";
import GalleryVideo from "../components/Gallery-Video";
import DragGallery from "../components/Gallery-Drag";
import ParagraphText from "../components/Paragraph";
import GalleryTransitional from "./Gallery-Transitional";
import { Container, Break } from "../styles/components/Global/Global";
import Header from "../components/Header";
import Credits from "../components/Credits";
import ParagraphMix from "../components/Paragraph-Mix";
import FooterCredits from "./Footer-Credits";
import QuoteImage from "./Quote";

const Landing = () => {
  return (
    <>
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701091277-asap-rocky-1.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097844-01_mobile.png",
          },
        ]}
      />
      <Container $noPadding>
        <Credits />
        <Break $desktop />
        <Break $size="small" $mobile />
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="Let’s begin this cover story with a bit of a thought experiment:"
          text="&nbsp; Close your eyes and let your mind go blank, reader. Dwell in this emptiness for a moment. Now, I’d like you to try to think back to 2011. You’re at a loft party in Williamsburg. You feel the buzz of the BlackBerry in your pocket. Is that a flannel poking out from underneath that denim jacket? Remain here. Take another swig of that Pabst Blue Ribbon. Let the Katy Perry wash over you."
        />
        <Break $size="medium" />
        <Break $size="medium" $mobile />
        <ParagraphText
          width="medium"
          indent={true}
          padding={true}
          text="Now, come back, reader. Return to 2023. Open your eyes. Look around. Are any of those 2011 faces still here? Not many, right? But there are a few. Is there one particularly pretty one? Perhaps with braids? He’s got an air about him, huh? A certain <i>jiggy</i>-ness, let’s say."
        />
        <Break $desktop />
        <Break $size="small" $mobile />
        <ParagraphText
          width="medium"
          indent={true}
          padding={true}
          text="“Still to this day, to have that type of following, influence, control, and that power is magical and rare,” A$AP Rocky says, reflecting on his more than a decade in the public’s good graces. The Harlem-bred star, whose profile has only continued to grow since he was last featured in these pages in 2015, is calculated, media savvy, and newly a parent. He has some boundaries to maintain, but also some things he’d like to catch us up on. "
        />
        <Break $desktop />
        <Break $size="small" $mobile />
      </Container>
      <GalleryTransitional />
      <Break />
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701092100-asap-rocky-2.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097850-04_mobile.png",
            credits:
              "Top GIVENCHY Shorts LUKE TEIGEN, Jacket BALENCIAGA, Socks BOTTEGA VENETA, Shoes BOTTEGA VENETA, A$AP ROCKY’S OWN, Earrings DAVID YURMAN, Sunglasses, necklace, and belt A$AP ROCKY’S OWN",
            justify: "center",
          },
        ]}
      />
      <Break />
      <Container>
        <GalleryVideo
          srcs={[
            "https://www.datocms-assets.com/40484/1701092209-asap-rocky-3.png",
          ]}
          mobile="https://www.datocms-assets.com/40484/1701097856-05_mobile.png"
          credits="Top worn underneath GIVENCHY, Top and jewellery A$AP ROCKY’S OWN"
          videoId={887703696}
          wrap="split"
          reverse={true}
        />
        <Break $size="large" />
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="When his first songs hit the Internet 12 summers ago, they ushered in a paradigm shift."
          text="&nbsp; New York, hip hop’s ancestral home, was experiencing a period of dormancy. It had been nearly a decade since 50 Cent’s meteoric rise. And while Nicki Minaj’s Barbie-sized shoulders were doing more than their fair share to carry the city through this drought, things still lacked a little juice. New York was in need of something different, a new flavor to drag the city out of the shadow of its gilded past and into the future. Rocky and his mob of Black Scale and Rick Owens–clad co-conspirators were just that."
        />
        <Break $size="medium" />
        <ParagraphText
          width="medium"
          indent={true}
          padding={true}
          text="He certainly sounded new. Released in the fall of 2011, his first mixtape <i>LIVE.LOVE.A$AP</i>’s fusion of Memphis and Houston-indebted flows, spaced-out cloud rap production, and distinctly uptown swag was like a shot of adrenaline into the New York rap world’s heart. “Peso,” the single that would land Rocky on Hot 97’s hallowed airwaves for the first time, played like a compilation of all of regional rap’s best impulses: There were syncopated sprinkles of Bone Thugs, syrupy splashes of Pimp C, and the slick bravado of JAY-Z’s ’90s New York. At times a woozy, smoke-filled kickback and at others a raucous warehouse party, it was, as Jon Caramanica wrote in <i>The New York Times</i>, “deeply assured and heavily narcotic,” the rare instance where an artist emerged fully formed with 
          their own unique look and sound."
        />
        <Break />
      </Container>
      <DragGallery
        srcs={[
          "https://www.datocms-assets.com/40484/1701092511-asap-rocky-4.png",
          "https://www.datocms-assets.com/40484/1701171832-quote_03_mobile-6.png",
        ]}
        credits="Coat worn underneath LUKE TEIGEN, Pants ACNE STUDIOS, Jacket CASPER WRIGHT, Sunglasses GENTLE MONSTER X MAISON MARGIELA, Earrings A$AP ROCKY’S OWN, Shoes BOTTEGA VENETA, A$AP ROCKY’S OWN"
      />
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701097861-07_mobile.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097861-07_mobile.png",
            credits:
              "Coat worn underneath LUKE TEIGEN, Pants ACNE STUDIOS, Jacket CASPER WRIGHT, Sunglasses GENTLE MONSTER X MAISON MARGIELA, Earrings A$AP ROCKY’S OWN, Shoes BOTTEGA VENETA, A$AP ROCKY’S OWN",
            justify: "center",
            padding: false,
            indent: false,
          },
        ]}
        mobile={true}
      />
      <Break $mobile />
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701172668-02_quote_mobile.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701172668-02_quote_mobile.png",
            padding: false,
          },
        ]}
        mobile={true}
      />
      <Break $size="medium" />
      <Break $size="medium" $mobile />
      <Container>
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="But even a breakout moment as momentous as Rocky’s doesn’t guarantee a lasting career. "
          text="&nbsp; All these years later, the now 35-year-old — and dad twice over with his partner, Rihanna (“being a parent changes everything for you,” he says) — is still a pop culture fixation. He’s a celebrity of the first order. The type of figure whose nice outfits command media coverage. How has Rocky done it? How has he managed to stay relevant in an entertainment landscape that has only grown more fickle and oversaturated since he first arrived? "
        />
        <Break $size="medium" />
        <ParagraphText
          width="medium"
          padding={true}
          indent={true}
          text="The answer seems to lie, at least partially, in the company Rocky keeps. Over the years, he has collaborated with seemingly everyone. He’s dueted with Lana Del Rey, partnered extensively with British cult figure Dean Blunt, penned party anthems with Kendrick Lamar, and boosted cars with FKA twigs. He possesses aesthetic versatility shared by few others. This chameleonic quality, consummate charm, and creative polyglotism have helped endear him to audiences that extend far beyond the world of New York City hip hop. How many people on this planet can just as easily chop it up with N.O.R.E. on Drink Champs as they can cozy up with Michèle Lamy at Paris Fashion Week?"
        />
        <Break $size="medium" />
      </Container>
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701092913-asap-rocky-5.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097866-09-01_mobile.png",
            credits:
              "Top GIVENCHY, Pants COMME DES GARÇONS HOMME PLUS, Earrings DAVID YURMAN, Necklaces and socks A$AP ROCKY’S OWN, Shoes ERL",
            justify: "flex-start",
            padding: false,
          },
          {
            src:
              "https://www.datocms-assets.com/40484/1701092920-asap-rocky-6.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097870-09-02_mobile.png",
            credits:
              "Top GIVENCHY, Pants and jacket COMME DES GARÇONS HOMME PLUS, Sunglasses KWK BY KAYKWOK, Earrings DAVID YURMAN, Necklaces, A$AP ROCKY’S OWN, Shoes ERL",
            justify: "flex-start",
            padding: false,
          },
        ]}
      />
      <Container>
        <Break $size="large" $desktop />
        <Break $size="medium" $mobile />
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="These sorts of things may seem almost banal now with hip hop having infiltrated nearly every crevice of fashion, music, and pop culture,"
          text="&nbsp; but Rocky’s arrival on the scene was a major catalyst in bridging these worlds. As he was establishing himself as rap’s “Fashion Killa,” New York contemporaries such as Virgil Abloh, Matthew M. Williams, and Heron Preston had only just begun to plot their infiltration of the fashion establishment. In this way, he was an early adopter of a practice that has seemingly become industry standard: diversify, diversify, diversify."
        />
        <Break $size="medium" />
        <ParagraphText
          width="medium"
          indent={true}
          padding={true}
          text="We simply do not have enough space in this article to name all the collaborations Rocky has been a part of in the last decade (“Everything that I am working on excites me — or I wouldn’t be doing it!”), but here are just a few: a sneaker with Under Armour, a capsule collection with cutting edge French designer Marine Serre (partially designed while behind bars in Sweden), a signature pair of Vans, an appointment as PacSun’s guest artistic director, and a collaboration with Mercedes-Benz. “The industry is always evolving, and changes give opportunities to different ideas. I think it is important to try to embrace the newness and the ever-changing world,” Rocky says of his multidisciplinary engagements. In the last two years alone, he started a new whisky brand, Mercer + Prince, directed a commercial for Beats, and was recently named the creative director of Puma’s joint venture with Formula 1. This last post was more unexpected and in a space that he describes as being “very traditional.” He’s hoping to “shake the room up a bit.”"
        />
        <Break $desktop />
        <Break $size="small" $mobile />
        <ParagraphText
          width="large"
          padding={true}
          bold={true}
          text="That’s all before we even get to the music."
        />
        <Break $size="small" />
        <Break $size="medium" $mobile />
        <GalleryVideo
          srcs={[
            "https://www.datocms-assets.com/40484/1701093026-asap-rocky-7.png",
          ]}
          mobile="https://www.datocms-assets.com/40484/1701097875-11_mobile.png"
          credits="Earring A$AP ROCKY’S OWN"
          videoId={887703696}
          wrap="overlap"
        />
        <Break $size="medium" />
      </Container>
      <Container>
        <Break $size="medium" $desktop />
        <Break $size="small" $mobile />
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="It’s been a full five years since his last studio album, <i>Testing</i> came out."
          text="&nbsp; Though his most stylistically adventurous, the record was met with relatively tepid reviews, with some critics citing a lack of substance behind all the style and flair. Rocky describes the response to the album and its underwhelming commercial performance in a GQ profile in 2021; he said he was “emotionally discouraged.” However, in the last year, Rocky has rolled out a string of singles and some of his most compelling work in recent memory."
        />
        <Break $size="medium" />
      </Container>
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701093094-asap-rocky-8.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097880-13_mobile.png",
            title: "From left to right",
            credits:
              "Thoto wears top worn on head CALVIN KLEIN, Sunglasses PORT TANGER, A$AP wears top, sunglasses, and jewelry A$AP ROCKY’S OWN, Tommy wears top worn on head CALVIN KLEIN, Sunglasses CELINE HOMME BY HEDI SLIMANE",
            justify: "center",
            padding: false,
            widthSize: true,
          },
        ]}
      />
      <Break $size="medium" />
      <Container>
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="Last May, Rocky released “D.M.B.,” or “DAT$ MAH B!*$H,” a paean to the world’s most beloved Barbadian pop star and the mother of his two children."
          text="&nbsp; Sonically, the song is a return to the genre-melding sound that first won him listeners all those years ago. The production — handled by a committee of all stars, including Skepta and LA stalwart Shlohmo — is a hypnotic slowburn that builds to the anthemic proclamation of love as Rocky croons, “You’re my soulmate, my goddess.” He debuted the song with a blockbuster music video that casts him and Rihanna as Mr. and Mrs. Outer-borough."
        />
        <Break $size="medium" />
        <ParagraphText
          width="medium"
          indent={true}
          padding={true}
          text="The pair lounge on a fire escape in Timberland boots and sorbet-toned furs; Rocky retrieves Rihanna at the hair salon in a studded Manchester United kit; Rihanna struts down the block in a knitted bikini top as neighborhood kids help her with the groceries. It’s a kaleidoscopic montage of coupled city bliss. In the video’s most poignant moment, the pair are wed in the hallway of a humble apartment complex. They lock eyes and he smiles, revealing a gleaming pair of custom fronts that say “MARRY ME?” She smiles in turn, a jewel-encrusted “I DO” capping her left canine."
        />
        <Break $size="medium" />
        <GalleryImages
          images={[
            {
              src:
                "https://www.datocms-assets.com/40484/1701093194-asap-rocky-9.png",
              mobile:
                "https://www.datocms-assets.com/40484/1701097884-15_01.png",
              credits:
                "Top S.R. STUDIO. LA. CA. Pants, sunglasses, ring, and belt A$AP ROCKY’S OWN, Earrings DAVID YURMAN, Shoes BOTTEGA VENETA, A$AP ROCKY’S OWN",
              justify: "flex-start",
              padding: false,
              indent: false,
              balance: true,
            },
            {
              src:
                "https://www.datocms-assets.com/40484/1701093509-asap-rocky-11.png",
              mobile:
                "https://www.datocms-assets.com/40484/1701097889-15_02_mobile.png",
              credits:
                "Hoodie F1 X PUMA, Pants JW ANDERSON, Sunglasses MONCLER LUNETTES, Earrings A$AP ROCKY’S OWN, Gloves F1 X PUMA X A$AP ROCKY, Boots BALENCIAGA",
              justify: "flex-start",
              padding: false,
              indent: false,
            },
          ]}
        />
      </Container>
      <Break $size="xlarge" $desktop />
      <Break $size="medium" $mobile />
      <DragGallery
        srcs={[
          "https://www.datocms-assets.com/40484/1701094998-asap-rocky-15.png",
          "https://www.datocms-assets.com/40484/1701115577-asap-drag-quote-3.png",
        ]}
        credits="Top worn underneath GIVENCHY, Hoodie XULY.BËT, Coat worn underneath BALENCIAGA, Coat and pants JW ANDERSON, Sunglasses MONCLER LUNETTES, Shoes FENTY X PUMA"
      />
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701097893-16_mobile.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701097893-16_mobile.png",
            credits:
              "Top worn underneath GIVENCHY, Hoodie XULY.BËT, Coat worn underneath BALENCIAGA, Coat and pants JW ANDERSON, Sunglasses MONCLER LUNETTES, Shoes FENTY X PUMA",
            justify: "flex-start",
            padding: false,
            indent: false,
          },
        ]}
        mobile={true}
      />
      <Break $mobile />
      <GalleryImages
        images={[
          {
            src:
              "https://www.datocms-assets.com/40484/1701172673-03_quote_mobile.png",
            mobile:
              "https://www.datocms-assets.com/40484/1701172673-03_quote_mobile.png",
            padding: false,
          },
        ]}
        mobile={true}
      />
      <Container>
        <Break $size="large" $desktop />
        <Break $size="medium" $mobile />
        <ParagraphMix
          size="xlarge"
          parallax={false}
          heading="He’s followed “D.M.B” with “Same Problems?,” a more somber tune"
          text="&nbsp; released this past January on “Yams Day,” the date chosen to honor his late friend and collaborator A$AP Yams, who passed away in 2015. This July, he unleashed “Riot (Rowdy Pipe’n),” a punchy, brassy anthem produced by Pharrell and Tyler, the Creator. The song’s are believed to be the lead singles on his forthcoming project Don’t Be Dumb."
        />
        <Break $size="medium" />
        <ParagraphText
          width="medium"
          padding={true}
          indent={true}
          text="Rocky doesn’t see himself leaving the spotlight anytime soon. “I think while I’m still here, I got a duty to aspire to inspire,” he says. He still considers himself top of his class."
        />
        <Break $desktop />
        <ParagraphText
          width="large"
          padding={true}
          bold={true}
          text="“There’s really only a few people who control the culture, and when I tell you that I’m at the forefront, believe dat!”"
        />
        <Break $size="medium" />
        <GalleryStacked
          src="https://www.datocms-assets.com/40484/1701094318-asap-rocky-13.png"
          mobile="https://www.datocms-assets.com/40484/1701097897-18_mobile.png"
          direction="left"
          credits="Top GIVENCHY, Pants COMME DES GARÇONS HOMME PLUS, Earrings DAVID YURMAN, Necklaces and socks A$AP ROCKY’S OWN, Shoes ERL"
        />
        <Break $size="medium" />
        <QuoteImage />
        <Break $size="medium" />
        <GalleryStacked
          src="https://www.datocms-assets.com/40484/1701094422-asap-rocky-14.png"
          mobile="https://www.datocms-assets.com/40484/1701097902-20_mobile.png"
          credits="Jacket GUCCI, Sunglasses CHRISHABANA, Earring DAVID YURMAN"
        />
        <Break $size="xlarge" />
        <ParagraphText
          width="large"
          padding={true}
          bold={true}
          align="center"
          text='<a href="https://www.highsnobiety.com/en-de/shop/product/highsnobiety-magazine-winter-2023/"
target="_blank">Head here</a> to get a copy of the new issue of Highsnobiety Magazine. '
        />
        <Break $size="small" />
        <Header />
      </Container>
      <Container>
        <Break $size="large" $mobile />
        <FooterCredits />
      </Container>
    </>
  );
};

export default Landing;
